module.exports = __webpack_public_path__ + "img/VIOR.6029fb1f.svg";